import React, { createContext, useContext, useState, useEffect } from 'react';
import { io } from 'socket.io-client';
import { API_URL } from '../utils/ApiUrl';

const SocketContext = createContext();

export const useSocket = () => {
    return useContext(SocketContext);
};

export const SocketProvider = ({ children, accessToken }) => {
    const [socket, setSocket] = useState(null);

    const getSocket = async (val) => {
        const socketInstance = io(API_URL, {
            transports: ["websocket", "polling"],
            auth: {
                Authorization: `Bearer ${val}`,
            },
        });

        socketInstance.on('disconnect', () => {
            // console.log('Disconnected from the server');
        });

        socketInstance.on('connect', () => {
            // console.log('Connected to the server');
            // localStorage.setItem('socketConnected', 'true');
        });

        socketInstance.on('error', (error) => {
            console.error('Connection error: ', error.message);
        });

        // Store socket instance in state
        setSocket(socketInstance);

        // Optionally, store it in localStorage
        // localStorage.setItem('socketInstance', JSON.stringify(socketInstance));
    };

    useEffect(() => {
        if (accessToken || localStorage.getItem('accessToken')) {
            getSocket(accessToken || localStorage.getItem('accessToken'));
        }
    }, [accessToken]);

    return (
        <SocketContext.Provider value={socket}>
            {children}
        </SocketContext.Provider>
    );
};
